<script>
import { mapGetters } from 'vuex';
import ReportRiskHeader from '@/V2/documents/document-view/document-review-agent/ReportRiskHeader.vue';
import ReportVisualCheck from '@/V2/documents/document-view/document-review-agent/ReportVisualCheck.vue';
import ReportVerification from '@/V2/documents/document-view/document-review-agent/ReportVerification.vue';

export default {
  components: { ReportRiskHeader, ReportVisualCheck, ReportVerification },
  computed: {
    ...mapGetters(['getDocumentReviewAgentRunsForDocId']),
    latestRun() {
      const runs = this.getDocumentReviewAgentRunsForDocId(
        this.$route.params.document_id,
      );
      return runs?.length > 0 ? runs[runs.length - 1] : null;
    },
  },
};
</script>

<template>
  <div
    v-if="latestRun"
    ref="overlayContent"
    class="d-flex flex-column i-p-10 i-gap-9 w-100 h-100"
  >
    <div class="d-flex flex-column align-items-start flex-grow-1 i-gap-1">
      <div class="name i-text-heading-6 i-text-neutral-120">
        Agent Summary Report
      </div>
      <div class="i-text-body-3 i-text-neutral-110">Complete</div>
    </div>
    <div class="d-flex flex-column i-gap-6">
      <ReportRiskHeader
        :risk-level="latestRun.output.risk_level"
        :confidence="latestRun.output.confidence"
      ></ReportRiskHeader>

      <div
        class="document-review-agent-report__section d-flex flex-column align-items-start i-gap-8 i-p-10 analysis-summary"
      >
        <div class="i-text-heading-6 i-text-neutral-120">Analysis</div>
        <div
          class="i-text-body-3 i-text-neutral-120 d-flex flex-column i-gap-8"
        >
          <p v-for="item in latestRun.output.analysis_paragraphs" :key="item">
            {{ item }}
          </p>
        </div>
      </div>

      <div
        v-if="latestRun.output.visual_checks"
        class="document-review-agent-report__section d-flex flex-column align-items-start i-gap-8 i-p-10"
      >
        <div class="i-text-heading-6 i-text-neutral-120">Visual Checks</div>
        <p
          v-if="latestRun.output.visual_checks.length === 0"
          class="i-text-body-3 i-text-neutral-110"
        >
          No Visual Checks performed
        </p>
        <div v-else class="d-flex flex-column align-items-start w-100 i-gap-6">
          <ReportVisualCheck
            v-for="(visualCheck, index) in latestRun.output.visual_checks"
            :key="index"
            :index="index"
            :title="visualCheck.title"
            :result="visualCheck.result"
            :rationale="visualCheck.rationale"
          />
        </div>
      </div>

      <div
        v-if="latestRun.output.verifications?.length > 0"
        class="document-review-agent-report__section d-flex flex-column align-items-start i-gap-8 i-p-10"
      >
        <div class="i-text-heading-6 i-text-neutral-120">Verifications</div>
        <div class="d-flex flex-column align-items-start i-gap-9">
          <div class="d-flex flex-column align-items-start i-gap-9">
            <ReportVerification
              v-for="(verification, index) in latestRun.output.verifications"
              :key="index"
              :index="index"
              :title="verification.title"
              :result="verification.result"
              :rationale="verification.rationale"
              :urls="verification.urls"
            >
            </ReportVerification>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.document-review-agent-report {
  &__section {
    border: 1px solid $light-neutral-60;
    border-radius: 16px;
  }
}
</style>
